<main class="shippn-b2b-pages-main-wrapper">
  <aside class="shippn-b2b-pages-nav-wrapper">
    <div class="shippn-b2b-pages-nav-profile">
      <h5 translate="no">
        {{memberDetails?.company_name}}
        <span class="show-on-hover" (click)="copyToClipboard(memberDetails?.email, 'Email')">{{memberDetails?.email}}</span>
      </h5>
    </div>
    <div class="shippn-b2b-pages-nav-menu">
      <button [routerLink]="['/', 'b2b', 'create-shipment']"> <i class="fas fa-box-open"></i> Create Shipment</button>
      <button [routerLink]="['/', 'b2b', 'dashboard']" class="active"> <i class="fas fa-boxes"></i> Shipments</button>
      <button [routerLink]="['/', 'b2b', 'pickups']"> <i class="fas fa-shipping-fast"></i> Pickups</button>
    </div>

    <div class="shippn-b2b-page-nav-footer for-desktop">
      <button class="btn btn-light" [routerLink]="['/', 'settings', 'api-keys']"><i class="fas fa-user-cog"></i> Account Settings</button>
      <div style="display: flex; justify-content: center; margin-top: 15px;">
        <a [routerLink]="['/', 'b2b', 'shipments']" style="font-size: 13px; text-align: center;">Switch to old version</a>
      </div>
    </div>
  </aside>
  <section class="shippn-b2b-pages-content-wrapper">
    <div class="shippn-b2b-pages-content-filters-wrapper">
      <div class="for-mobile filters-mobile-btn-wrapper container">
        <button class="btn filter-btn" (click)="filterControlsContainer = !filterControlsContainer">
            <i class="fas fa-stream" *ngIf="!filterControlsContainer"></i>
            <i class="fas fa-bars" *ngIf="filterControlsContainer"></i>
            Filters
        </button>
       </div>
       <div class="b2b-dashboards-filter-controls-wrapper for-mobile display-flex container" *ngIf="filterControlsContainer">
        <div class="b2b-dashboards-filters-search-box">
          <i class="fas fa-search"></i>
          <input type="text" class="b2b-dashboards-filters-search-input form-control" placeholder="Search shipments..." [(ngModel)]="filters.searchQuery" (input)="applyFilters()" (keypress)="searchWithEnter($event)">
        </div>
        <div class="carrier">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.company_id" (change)="applyFilters()">
              <option value="all">All Carriers</option>
              <option value="1">TNT</option>
              <option value="2">UPS</option>
              <option value="3">DHL</option>
              <option value="4">Fedex</option>
              <option value="5">AusPost</option>
              <option value="6">USPS</option>
              <option value="7">Aramex</option>
              <option value="8">LaPoste</option>
              <option value="9">ChronoPost</option>
              <option value="10">PostNord</option>
              <option value="11">MNG</option>
              <option value="12">EMS</option>
              <option value="13">DPD</option>
              <option value="14">Evri</option>
            </select>
          </div>
        </div>
        <div class="shipment-status">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.status" (change)="applyFilters()">
              <option value="all">All Statuses</option>
              <option value="0">Canceled</option>
              <option value="6">Waiting Payment</option> 
              <option value="7">Ready To Shipment</option> 
              <option value="8">Shipped / In Transit</option> 
              <option value="9">Delivered</option> 
              <option value="98">Label Failed</option> 
            </select>
          </div>
        </div>
        <div class="pickup-status">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.pickup_status" (change)="applyFilters()">
              <option value="all">All Pickup Statuses</option>
              <option value="0">Unscheduled</option> 
              <option value="1">Scheduled</option>
              
            </select>
          </div>
        </div>
        <div class="date-range">
          <div class="shipment-status">
            <div class="select--wrapper">
              <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
              <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
              [(ngModel)]="filters.date_range" (change)="applyFilters()">
                <option value="none">No Date Range</option>
                <option value="today">Today</option>
                <option value="last_7_days">Last 7 days</option> 
                <option value="last_30_days">Last 30 days</option> 
                <option value="custom">Custom Range</option>
              </select>
            </div>
          </div>
        </div>
        <div class="b2b-shipmentlists-date-range-picker" *ngIf="filters.date_range == 'custom'">
          <mat-form-field appearance="fill" class="width-100per">
            <mat-date-range-input  [formGroup]="range" [rangePicker]="picker"
                class="host-availability-mat-date-range-picker">
                <input matStartDate placeholder="Start Date"
                    class="host-availability-mat-date-range-picker-input" formControlName="start">
                <input matEndDate placeholder="End Date"
                    class="host-availability-mat-date-range-picker-input" formControlName="end">
            </mat-date-range-input>
            <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        </div>
      </div>
      <div class="b2b-dashboards-filter-controls-wrapper for-desktop">
        <div class="environment">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.environment">
              <option value="Environment">Environment</option>
              <option value="production">Production</option>
              <option value="test" [disabled]="!xApiToken">Test</option>
            </select>
          </div>
        </div>
        <div class="b2b-dashboards-filters-search-box">
          <i class="fas fa-search"></i>
          <input type="text" class="b2b-dashboards-filters-search-input form-control" placeholder="Search shipments..." [(ngModel)]="filters.searchQuery" (keypress)="searchWithEnter($event)">
        </div>
        <div class="carrier">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.company_id">
              <option value="all">All Carriers</option>
              <option value="1">TNT</option>
              <option value="2">UPS</option>
              <option value="3">DHL</option>
              <option value="4">Fedex</option>
              <option value="5">AusPost</option>
              <option value="6">USPS</option>
              <option value="7">Aramex</option>
              <option value="8">LaPoste</option>
              <option value="9">ChronoPost</option>
              <option value="10">PostNord</option>
              <option value="11">MNG</option>
              <option value="12">EMS</option>
              <option value="13">DPD</option>
              <option value="14">Evri</option>
            </select>
          </div>
        </div>
        <div class="shipment-status">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.status">
              <option value="all">All Statuses</option>
              <option value="0">Canceled</option>
              <option value="6">Waiting Payment</option> 
              <option value="7">Ready To Shipment</option> 
              <option value="8">Shipped / In Transit</option> 
              <option value="9">Delivered</option> 
              <option value="98">Label Failed</option> 
            </select>
          </div>
        </div>
        <div class="pickup-status">
          <div class="select--wrapper">
            <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
            <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
            [(ngModel)]="filters.pickup_status">
              <option value="all">All Pickup Statuses</option>
              <option value="0">Unscheduled</option> 
              <option value="1">Scheduled</option>
              
            </select>
          </div>
        </div>
        <div class="date-range">
          <div class="shipment-status">
            <div class="select--wrapper">
              <i class="fas fa-chevron-down" style="position: absolute; right: 14px!important; top: 13px!important;float: right; color: #222222; font-size: 12px;" aria-hidden="true"></i>
              <select name="" id="" style=" width: 100%; border-radius: 5px;padding: 6px 12px;height: 38px;margin-right: 10px;font-size: 13px;"
              [(ngModel)]="filters.date_range">
                <option value="none">No Date Range</option>
                <option value="today">Today</option>
                <option value="last_7_days">Last 7 days</option> 
                <option value="last_30_days">Last 30 days</option> 
                <option value="custom">Custom Range</option>
              </select>
            </div>
          </div>
        </div>
        <div class="b2b-shipmentlists-date-range-picker" *ngIf="filters.date_range == 'custom'">
          <mat-form-field appearance="fill" class="width-100per">
            <mat-date-range-input  [formGroup]="range" [rangePicker]="picker"
                class="host-availability-mat-date-range-picker">
                <input matStartDate placeholder="Start Date"
                    class="host-availability-mat-date-range-picker-input" formControlName="start">
                <input matEndDate placeholder="End Date"
                    class="host-availability-mat-date-range-picker-input" formControlName="end">
            </mat-date-range-input>
            <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        </div>
        <div class="b2b-dashboards-filters-button-wrapper">
          <button class="btn btn-dark" (click)="applyFilters()">Apply Filters</button>
        </div>
      </div>

    </div>

    <div class="shippn-b2b-pages-content-content-wrapper" (scroll)="onScroll($event)">
      <div class="b2b-dashboard-table-wrapper">
        <div class="b2b-dashboard-table-head">
          <div class="b2b-dashboard-table-head-item areaHeadData">Date</div>
          <div class="b2b-dashboard-table-head-item areaHeadShipmentNumber">Shipment Number</div>
          <div class="b2b-dashboard-table-head-item areaHeadCarrier">Carrier</div>
          <div class="b2b-dashboard-table-head-item areaHeadOrigin">Origin</div>
          <div class="b2b-dashboard-table-head-item areaHeadDestination">Destination</div>
          <div class="b2b-dashboard-table-head-item areaHeadRecipient">Recipient</div>
          <div class="b2b-dashboard-table-head-item areaHeadStatus">Status</div>
          <div class="b2b-dashboard-table-head-item areaHeadTracking">Tracking Number</div>
          <div class="b2b-dashboard-table-head-item areaHeadCost">Cost</div>
          <div class="b2b-dashboard-table-head-item areaHeadAction"></div>
        </div>
        <div class="b2b-dashboard-table-body">

          <div class="b2b-dashboard-table-body-item-wrapper" *ngFor="let shipment of shipmentsListData; let i = index">
            <div class="b2b-dashboard-table-body-item areaNameDate" translate="no">{{shipment?.created_date * 1000 | date:"dd.MM.yyyy HH:mm"}}</div>
            <div class="b2b-dashboard-table-body-item areaNameShipmentNumber">
              {{shipment?.shipment_number}}
            </div>
            <div class="b2b-dashboard-table-body-item areaNameCarrier">
              {{shipment?.shipment?.company_name}}
            </div>
            <div class="b2b-dashboard-table-body-item areaNameOrigin">
              {{shipment?.shipment?.country_code}}
            </div>
            <div class="b2b-dashboard-table-body-item areaNameDestination">{{shipment?.shipment?.zone}}</div>
            <div class="b2b-dashboard-table-body-item areaNameRecipient">
              {{shipment?.recipient_full_name}}
            </div>
            <div class="b2b-dashboard-table-body-item areaNameStatus">{{shipment?.status_name}}</div>
            <div class="b2b-dashboard-table-body-item areaNameTracking">
              <a href="{{shipment?.shipment?.tracking_number}}" target="_blank" rel="noopener nofollow">{{shipment?.shipment?.tracking_link}}</a>
            </div>
            <div class="b2b-dashboard-table-body-item areaNameCost">
              <span *ngIf="shipment?.charge?.paid?.amount">${{shipment?.charge?.paid?.amount}}</span>
              <span *ngIf="!shipment?.charge?.paid?.amount">N/A</span>
            </div>
            <div class="b2b-dashboard-table-body-item areaNameAction">
              <button class="b2b-dashboard-table-body-item-button" (click)="toggleDetailsOfShipment(i)">Details <i class="fas fa-caret-up" *ngIf="shipment?.show_details === true"></i><i class="fas fa-caret-down" *ngIf="shipment?.show_details === false"></i></button>
            </div>
            <div class="b2b-dashboard-table-body-detail-item areaNameDetails" *ngIf="shipment?.show_details === true">
              <div class="b2b-dashboard-table-body-detail-item-details-wrapper">
                <div class="b2b-dashboard-table-body-detail-item-details-json">
                  <ngx-json-viewer [json]="shipment" [expanded]="false"></ngx-json-viewer>
                </div>
                <div class="b2b-dashboard-table-body-detail-item-details-right">
                  <div class="b2b-dashboard-table-body-detail-item-details-right-from">
                    <div class="b2b-dashboard-table-body-detail-item-details-right-from-title" style="font-size: 20px; color: #AAA;">From</div>
                    <div class="b2b-dashboard-table-body-detail-item-details-right-from-content">
                      <div class="b2b-dashboard-table-body-detail-item-details-right-from-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-from-content-item-value">{{shipment?.b2b_user_address?.name}}</div>
                      </div>
                      <div class="b2b-dashboard-table-body-detail-item-details-right-from-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-from-content-item-value">
                          {{shipment?.b2b_user_address?.street1}} {{shipment?.b2b_user_address?.street2}} <br>
                          {{shipment?.b2b_user_address?.city}} / {{shipment?.b2b_user_address?.state}}
                          {{shipment?.b2b_user_address?.zip}} / {{shipment?.b2b_user_address?.country}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="b2b-dashboard-table-body-detail-item-details-right-to">
                    <div class="b2b-dashboard-table-body-detail-item-details-right-to-title" style="font-size: 20px; color: #AAA;">To</div>
                    <div class="b2b-dashboard-table-body-detail-item-details-right-to-content">
                      <div class="b2b-dashboard-table-body-detail-item-details-right-to-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-to-content-item-value">{{shipment?.recipient_address?.name}}</div>
                      </div>
                      <div class="b2b-dashboard-table-body-detail-item-details-right-to-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-to-content-item-value">
                          {{shipment?.recipient_address?.street1}} {{shipment?.recipient_address?.street2}} <br>
                          {{shipment?.recipient_address?.city}} / {{shipment?.recipient_address?.state}}
                          {{shipment?.recipient_address?.zip}} / {{shipment?.recipient_address?.country}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="b2b-dashboard-table-body-detail-item-details-right-parcel">
                    <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-title" style="font-size: 20px; color: #AAA;">Parcel</div>
                    <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-content">
                      <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-content-item-value">
                          {{shipment?.parcel?.length}} x {{shipment?.parcel?.width}} x {{shipment?.parcel?.height}} <span>({{shipment?.parcel?.dimension_unit}})</span></div>
                      </div>
                      <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-content-item">
                        <div class="b2b-dashboard-table-body-detail-item-details-right-parcel-content-item-value">{{shipment?.parcel?.weight}} <span>({{shipment?.parcel?.weight_unit}})</span></div>
                      </div>
                    </div>
                  </div>

                  <div class="b2b-dashboard-table-body-detail-item-details-right-actions">
                    <button class="btn btn-outline" (click)="openTrackingPage(shipment?.tracking_number)" [disabled]="!shipment?.tracking_number">Track <i class="fas fa-truck"></i></button>
                    <button class="btn btn-outline" (click)="openLabelUrl(shipment?.label_url)" [disabled]="!shipment?.label_url">Label <i class="fas fa-download"></i></button>
                    <button class="btn btn-outline" (click)="openShipmentReceipt(shipment?.receipt_url)" [disabled]="!shipment?.receipt_url">Receipt <i class="fas fa-receipt"></i></button>
                    <button class="btn btn-outline" (click)="openRefundDialog(shipment?.id, shipment?.tracking_number)" [disabled]="shipment?.status !== 7">Refund <i class="fas fa-undo-alt"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-indicator" *ngIf="isLoading" style="text-align: center; padding: 20px;">
        <i class="fas fa-spinner fa-spin"></i> Loading more shipments...
      </div>
      <div class="no-more-data" *ngIf="!hasMoreData && shipmentsListData?.length >= 0" style="text-align: center; padding: 20px; color: #666;">
        No more shipments to load
      </div>
    </div>
  </section>
</main>